<app-dialog-header
	[title]="'booklet.praticaAuto' | translate"
	(closeClick)="close()"
/>

<mat-dialog-content>
	<div class="booklet-subtitle">
		<strong>{{ "booklet.praticaTrasferimento" | translate }}</strong>
	</div>

	<!-- FORM -->
	<form [formGroup]="bookletForm">
		<section class="form">
			<div class="row">
				<!-- License plate -->
				<div class="field col-sm-12 text-start">
					<app-formx-input
						[label]="'booklet.licensePlate' | translate"
						[control]="bookletForm.get('licensePlate')"
						[required]="true"
						[maxlength]="50"
					>
					</app-formx-input>
				</div>

				<!-- VAT code -->
				<div class="field col-sm-12 text-start">
					@if (dealer) {
						@if (isAdmin) {
							<app-formx-input
								[label]="'booklet.vatCode' | translate"
								[control]="bookletForm.get('vatCode')"
								[required]="true"
								[maxlength]="50"
							>
							</app-formx-input>
						} @else {
							<label>
								{{ "booklet.vatCode" | translate }}
							</label>
							<span class="form-control-plaintext">
								{{ dealer.vatCode }}
							</span>
						}
					}
				</div>
			</div>
		</section>
	</form>
	<div class="booklet-warning-container">
		<img
			[src]="'assets/icons/info-solid.svg'"
			alt=""
			class="dialog-icon"
		/>
		<div class="booklet-warn">
			{{ "booklet.vatCodeWrong" | translate }}
			<strong> Tel.: 800993017 </strong>
		</div>
	</div>
</mat-dialog-content>

<div class="col-sm-12 text-center d-flex justify-content-end gap-3 pe-4 pb-3">
	<a
		(click)="close()"
		class="btn btn-outline text-uppercase"
	>
		{{ "confirmDialog.dialog.cancel" | translate }}
	</a>
	<a
		[class.disabled]="bookletForm.invalid"
		(click)="onConfirm()"
		class="btn btn-red text-uppercase"
	>
		{{ "email.button.send" | translate }}
	</a>
</div>